import {commitMutation, graphql} from 'react-relay';
import environment from '../data/environment';

const mutation = graphql`
  mutation CreateWidgetMutation(
    $input: CreateWidgetInput!
  ) {
    createWidget(input: $input) {
      widget {
        id
        mongoId
        name
        type
        config {
          filterComments
          sliceByQuestion
          aggregateQuestions
          subtitle
          ignoreDateFilter
          showLastXMonths
          hideHeader
          hideCommentTime
          staticYAxisScale
          commentExtraColumns {
            title
            questionId
          }
          question {
            id
            firstAnswerTime
          }
        }
      }
    }
  }
`;

function commit({reportId, name, type, config}) {
  commitMutation(
    environment,
    {
      mutation,
      variables: {
        input: {
          reportId,
          name,
          type,
          config: {
            filterComments: config.filterComments,
            sliceByQuestion: config.sliceByQuestion,
            aggregateQuestions: config.aggregateQuestions,
            subtitle: config.subtitle,
            ignoreDateFilter: config.ignoreDateFilter,
            showLastXMonths: config.showLastXMonths,
            hideHeader: config.hideHeader,
            hideCommentTime: config.hideCommentTime,
            staticYAxisScale: config.staticYAxisScale,
            commentExtraColumns: config.commentExtraColumns,
            question: config.question,
          },
        },
      },
      updater: (store) => {
        const payload = store.getRootField('createWidget');
        const newWidget = payload.getLinkedRecord('widget');
        const report = store.get(reportId);
        const widgets = report.getLinkedRecords('widgets');
        widgets.push(newWidget);
        report.setLinkedRecords(widgets, 'widgets');
      },
    },
  );
}

export default {commit};



// WEBPACK FOOTER //
// ./src/mutations/CreateWidgetMutation.js